// extracted by mini-css-extract-plugin
export default {"regulations":"MXRegulators-module__regulations___H97iQ","regulations--centered":"MXRegulators-module__regulations--centered___BnH9m","title":"MXRegulators-module__title___4kPr+"};